
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Checkbox } from "../Components/Checkbox.js";
import { ActivatedEmailNotification } from "../Shared/User.js";
import { defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export function EmailNotification(props) {
    let elems_1, elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems_1 = [reactElement("div", {
        className: join(" ", ["font-bold", "mb-1"]),
        children: t("user.email_notification.title"),
    }), Checkbox({
        ComponentState: props.FormState,
        IsChecked: props.User.ActivatedEmailNotification.ToolReservation,
        Label: t("user.email_notification.tool_reservation"),
        OnCheck: (_arg) => {
            let bind$0040;
            props.OnChangeEmailNotification((bind$0040 = props.User.ActivatedEmailNotification, new ActivatedEmailNotification(bind$0040.ToolReminder, bind$0040.InspectionReminder, bind$0040.ConsumableMinimumStock, bind$0040.ToolWithQuantityMinimumStock, bind$0040.CategoryMinimumStock, bind$0040.ProblemReport, !props.User.ActivatedEmailNotification.ToolReservation, bind$0040.ReleaseDate, bind$0040.ReturnDateReminder, bind$0040.StorageReservationAlert)));
        },
        TestId: "email-notification-tool-reservation",
    }), Checkbox({
        ComponentState: props.FormState,
        IsChecked: props.User.ActivatedEmailNotification.ProblemReport,
        Label: t("user.email_notification.problem_report"),
        OnCheck: (_arg_1) => {
            let bind$0040_1;
            props.OnChangeEmailNotification((bind$0040_1 = props.User.ActivatedEmailNotification, new ActivatedEmailNotification(bind$0040_1.ToolReminder, bind$0040_1.InspectionReminder, bind$0040_1.ConsumableMinimumStock, bind$0040_1.ToolWithQuantityMinimumStock, bind$0040_1.CategoryMinimumStock, !props.User.ActivatedEmailNotification.ProblemReport, bind$0040_1.ToolReservation, bind$0040_1.ReleaseDate, bind$0040_1.ReturnDateReminder, bind$0040_1.StorageReservationAlert)));
        },
        TestId: "email-notification-problem-report",
    }), Checkbox({
        ComponentState: props.FormState,
        IsChecked: props.User.ActivatedEmailNotification.ToolWithQuantityMinimumStock,
        Label: t("user.email_notification.toolwithquantity_minimum_stock"),
        OnCheck: (_arg_2) => {
            let bind$0040_2;
            props.OnChangeEmailNotification((bind$0040_2 = props.User.ActivatedEmailNotification, new ActivatedEmailNotification(bind$0040_2.ToolReminder, bind$0040_2.InspectionReminder, bind$0040_2.ConsumableMinimumStock, !props.User.ActivatedEmailNotification.ToolWithQuantityMinimumStock, bind$0040_2.CategoryMinimumStock, bind$0040_2.ProblemReport, bind$0040_2.ToolReservation, bind$0040_2.ReleaseDate, bind$0040_2.ReturnDateReminder, bind$0040_2.StorageReservationAlert)));
        },
        TestId: "email-notification-tool-with-quantity-minimum-stock",
    }), Checkbox({
        ComponentState: props.FormState,
        IsChecked: props.User.ActivatedEmailNotification.ConsumableMinimumStock,
        Label: t("user.email_notification.consumable_minimum_stock"),
        OnCheck: (_arg_3) => {
            let bind$0040_3;
            props.OnChangeEmailNotification((bind$0040_3 = props.User.ActivatedEmailNotification, new ActivatedEmailNotification(bind$0040_3.ToolReminder, bind$0040_3.InspectionReminder, !props.User.ActivatedEmailNotification.ConsumableMinimumStock, bind$0040_3.ToolWithQuantityMinimumStock, bind$0040_3.CategoryMinimumStock, bind$0040_3.ProblemReport, bind$0040_3.ToolReservation, bind$0040_3.ReleaseDate, bind$0040_3.ReturnDateReminder, bind$0040_3.StorageReservationAlert)));
        },
        TestId: "email-notification-consumable-minimum-stock",
    }), Checkbox({
        ComponentState: props.FormState,
        IsChecked: props.User.ActivatedEmailNotification.ToolReminder,
        Label: t("user.email_notification.tools_reminder"),
        OnCheck: (_arg_4) => {
            let bind$0040_4;
            props.OnChangeEmailNotification((bind$0040_4 = props.User.ActivatedEmailNotification, new ActivatedEmailNotification(!props.User.ActivatedEmailNotification.ToolReminder, bind$0040_4.InspectionReminder, bind$0040_4.ConsumableMinimumStock, bind$0040_4.ToolWithQuantityMinimumStock, bind$0040_4.CategoryMinimumStock, bind$0040_4.ProblemReport, bind$0040_4.ToolReservation, bind$0040_4.ReleaseDate, bind$0040_4.ReturnDateReminder, bind$0040_4.StorageReservationAlert)));
        },
        TestId: "email-notification-tools-reminder",
    }), Checkbox({
        ComponentState: props.FormState,
        IsChecked: props.User.ActivatedEmailNotification.InspectionReminder,
        Label: t("user.email_notification.inspection_reminder"),
        OnCheck: (_arg_5) => {
            let bind$0040_5;
            props.OnChangeEmailNotification((bind$0040_5 = props.User.ActivatedEmailNotification, new ActivatedEmailNotification(bind$0040_5.ToolReminder, !props.User.ActivatedEmailNotification.InspectionReminder, bind$0040_5.ConsumableMinimumStock, bind$0040_5.ToolWithQuantityMinimumStock, bind$0040_5.CategoryMinimumStock, bind$0040_5.ProblemReport, bind$0040_5.ToolReservation, bind$0040_5.ReleaseDate, bind$0040_5.ReturnDateReminder, bind$0040_5.StorageReservationAlert)));
        },
        TestId: "email-notification-inspection-reminder",
    }), Checkbox({
        ComponentState: props.FormState,
        IsChecked: props.User.ActivatedEmailNotification.ReleaseDate,
        Label: t("user.email_notification.release_date"),
        OnCheck: (_arg_6) => {
            let bind$0040_6;
            props.OnChangeEmailNotification((bind$0040_6 = props.User.ActivatedEmailNotification, new ActivatedEmailNotification(bind$0040_6.ToolReminder, bind$0040_6.InspectionReminder, bind$0040_6.ConsumableMinimumStock, bind$0040_6.ToolWithQuantityMinimumStock, bind$0040_6.CategoryMinimumStock, bind$0040_6.ProblemReport, bind$0040_6.ToolReservation, !props.User.ActivatedEmailNotification.ReleaseDate, bind$0040_6.ReturnDateReminder, bind$0040_6.StorageReservationAlert)));
        },
        TestId: "email-notification-release-date",
    }), Checkbox({
        ComponentState: props.FormState,
        IsChecked: props.User.ActivatedEmailNotification.ReturnDateReminder,
        Label: t("user.email_notification.return_date_reminder"),
        OnCheck: (_arg_7) => {
            let bind$0040_7;
            props.OnChangeEmailNotification((bind$0040_7 = props.User.ActivatedEmailNotification, new ActivatedEmailNotification(bind$0040_7.ToolReminder, bind$0040_7.InspectionReminder, bind$0040_7.ConsumableMinimumStock, bind$0040_7.ToolWithQuantityMinimumStock, bind$0040_7.CategoryMinimumStock, bind$0040_7.ProblemReport, bind$0040_7.ToolReservation, bind$0040_7.ReleaseDate, !props.User.ActivatedEmailNotification.ReturnDateReminder, bind$0040_7.StorageReservationAlert)));
        },
        TestId: "email-notification-return-date-reminder",
    }), Checkbox({
        ComponentState: props.FormState,
        IsChecked: props.User.ActivatedEmailNotification.StorageReservationAlert,
        Label: t("user.email_notification.storage_reservation_alert"),
        OnCheck: (_arg_8) => {
            let bind$0040_8;
            props.OnChangeEmailNotification((bind$0040_8 = props.User.ActivatedEmailNotification, new ActivatedEmailNotification(bind$0040_8.ToolReminder, bind$0040_8.InspectionReminder, bind$0040_8.ConsumableMinimumStock, bind$0040_8.ToolWithQuantityMinimumStock, bind$0040_8.CategoryMinimumStock, bind$0040_8.ProblemReport, bind$0040_8.ToolReservation, bind$0040_8.ReleaseDate, bind$0040_8.ReturnDateReminder, !props.User.ActivatedEmailNotification.StorageReservationAlert)));
        },
        TestId: "email-notification-storage-reservation-alert",
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "pt-4", "border-t", "border-gray-200"])], (elems = [reactElement("div", {
        className: join(" ", ["font-bold", "mb-1"]),
        children: t("user.newsletter.title"),
    }), Checkbox({
        ComponentState: props.FormState,
        IsChecked: defaultArg(props.User.NewsletterConsent, false),
        Label: t("user.newsletter.consent_label"),
        OnCheck: (_arg_9) => {
            props.OnChangeNewsletterConsent(!defaultArg(props.User.NewsletterConsent, false));
        },
        TestId: "newsletter-consent",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

